var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.apiLoading
        ? _c("v-skeleton-loader", {
            staticClass: "mx-auto",
            attrs: {
              "max-width": "300",
              type: "list-item, list-item, list-item",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.apiLoading && !_vm.apiUpcomingGroupEvents.length
        ? _c("div", { staticClass: "soli-grey px-10" }, [
            _vm._v(
              "\n        Sorry, there are no classes available at this time\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.apiUpcomingGroupEvents.length
        ? _c(
            "v-timeline",
            { attrs: { dense: "" } },
            _vm._l(_vm.apiUpcomingGroupEvents, function (groupEvent) {
              return _c(
                "v-timeline-item",
                {
                  key: groupEvent.id,
                  staticClass: "mb-5",
                  attrs: { "fill-dot": "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "icon",
                        fn: function () {
                          return [
                            _c("small", { staticClass: "white--text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.globalMomentWeekDayShort(
                                    groupEvent.starts_at
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "row soli-round",
                          on: {
                            click: function ($event) {
                              return _vm.$emit("input", groupEvent)
                            },
                          },
                        },
                        [
                          _c("v-col", [
                            _c("div", [
                              _c("small", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.globalMomentDateDots(
                                        groupEvent.starts_at
                                      )
                                    ) +
                                    "\n                                ·\n                                " +
                                    _vm._s(
                                      `${_vm.globalMomentTime(
                                        groupEvent.starts_at
                                      )}`
                                    )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("strong", [
                                _vm._v(_vm._s(groupEvent.group_event.title)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", { staticClass: "text-caption" }, [
                                _vm._v(
                                  "\n                                w/\n                                " +
                                    _vm._s(groupEvent.teacher.name) +
                                    "\n                                ·\n                                " +
                                    _vm._s(groupEvent.location.name) +
                                    "\n                            "
                                ),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }